import { Directive, Input, ChangeDetectorRef } from '@angular/core';
import { Model, IModelDataV3 } from '@df/catalog/model';
import { SocialService } from '@df/ui/social/social.service';

@Directive()
export abstract class SocialShareComponentDef {
    @Input({
        required: true
    })
    model!: Model<IModelDataV3>;

    constructor(
        protected socialService: SocialService,
        private ref: ChangeDetectorRef
    ) {}

    protected detectChanges(): void {
        this.ref.detectChanges();
    }

    fbShare(windowName?: string) {
        return this.socialService.fbShare(this.model, windowName);
    }

    fmShare(windowName?: string) {
        return this.socialService.fmShare(this.model, windowName);
    }

    twShare(windowName?: string) {
        return this.socialService.twShare(this.model, windowName);
    }

    gpShare(windowName?: string) {
        return this.socialService.gpShare(this.model, windowName);
    }

    pinShare(windowName?: string, image?: string) {
        return this.socialService.pinShare(this.model, windowName, image);
    }

    waShare(windowName?: string) {
        return this.socialService.waShare(this.model, windowName);
    }

    emailShare(email?: string) {
        return this.socialService.emailShare(this.model, email);
    }

    tumbShare(windowName?: string) {
        return this.socialService.tumbShare(this.model, windowName);
    }
}
